import { useEffect, useState } from 'react';
import { ProviderValue, useAxios } from '../../config/axios-config';
import { Meal } from '../../model/Meal';
import { Col, Container, Form, InputGroup, Row, Table } from 'react-bootstrap';
import { PageLoader } from '../util/PageLoader';
import { MealElement } from './MealElement';
import { MealRequestDTO } from '../../model/MealRequestDTO';
import { SaveEditMealModal } from '../modal/SaveEditMealModal';
import './style.css'
import { Pagination, Stack } from '@mui/material';
import { MealResponseDTO, MealsResponseDTO } from '../../model/ResponsesDTO';
import { Customer } from '../../model/Customer';
import { HeaderSorterColumn } from '../util/HeaderSorterColumn';
import { DinneyObject } from '../../model/DinneyObject';
import { isMobile } from 'react-device-detect';
import { MAX_MEALS } from '../util/DinneyConst';
import { Empty, Popover, Switch } from 'antd';
import { ErrorPage } from '../error/ErrorPage';
import { AlertBar } from '../util/AlertBar';
import { Entities } from '../util/Entities';
import { DinneyResponseStatus } from '../util/DinneyResponseStatus';
import {DinneyUtil} from "../util/DinneyUtil";

export const MealsPage = () => {

    const axiosInstance = useAxios() as ProviderValue

    const [mealList, setMealList] = useState<Meal[]>([])
    const [customerList, setCustomerList] = useState<Customer[]>([])
    const [filteredMealList, setFilteredMealList] = useState<Meal[]>([])
    const [isLoaded, setIsLoaded] = useState<boolean>(false)
    const [isError, setIsError] = useState<boolean>(false)
    const [show, setShow] = useState(false);
    const [filter, setFilter] = useState<string>('')
    const [filterActive, setFilterActive] = useState<boolean>(true)
    const [page, setPage] = useState<number>(1)
    const [count, setCount] = useState<number>(0)
    const controller = new AbortController();
    const signal = controller.signal

    useEffect(() => {
      axiosInstance.get<MealsResponseDTO>("/meals/secure/fetch/all", {signal})
      .then(response => {
        setCustomerList(response.data.customers)
        handleSort('position', true, response.data.meals)
        setIsLoaded(true)
      }).catch((e : any) => {
        setIsLoaded(true)
        setIsError(true)
        console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
      })
      return () => {
        controller.abort()
      }
    // eslint-disable-next-line
    },[])

    useEffect(() => { },[filter])
      
    const handleSaveToDatabase = async (mealRequestDTO : MealRequestDTO) => {
      setIsLoaded(false)
      let tempMeal : Meal | undefined
      let tempMealList = mealList
      if (mealRequestDTO.meal.mealid === undefined) {
        await axiosInstance.post<MealResponseDTO>(`/meals/secure/save`, mealRequestDTO, {signal}).then((response) => {
          tempMeal = response.data.meal
          tempMeal.customerMeals = []
        }).catch((e) => {
          setIsLoaded(true) 
          setIsError(true)
          console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
        })
        if (tempMeal !== undefined) {
          tempMealList.push(tempMeal)
        }
      } else {
        await axiosInstance.put<MealResponseDTO>(`/meals/secure/update`, mealRequestDTO).then((response) => {
          tempMeal = response.data.meal
        }).catch((e) => {
          setIsLoaded(true) 
          setIsError(true)
          console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
        })
        if (tempMeal !== undefined) {
          tempMealList = mealList.filter(meal => meal.mealid !== tempMeal?.mealid)
          tempMealList.push(tempMeal)
        }
      }
      handleSort('position', true, tempMealList)
      setFilterActive(true)
      setIsLoaded(true) 
      return () => {
        controller.abort()
      }
    }

    const handleDeleteOrRestore = async (id : number, isDelete : boolean) => {
      setIsLoaded(false)
      await axiosInstance.delete<MealResponseDTO>(`/meals/secure/${isDelete ? `d` : `r`}eactivate/${id}`, {signal}).then((response) => {
        let tempMeal = mealList.filter(meal => meal.mealid !== id)
        tempMeal.push(response.data.meal)
        handleSort('position', true, tempMeal)
        setIsLoaded(true)
      }).catch (e => {
        console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
        setIsLoaded(true)
        setIsError(true)
      })
      return () => {
        controller.abort()
      }
    };

    const handleHardDelete = async (id : number) => {
      setIsLoaded(false) 
      await axiosInstance.delete<DinneyResponseStatus>(`/meals/secure/delete/${id}`, {signal}).then((response) => {
        let tempMeal = mealList.filter(meal => meal.mealid !== id)
        handleSort('position', true, tempMeal)
        setIsLoaded(true) 
      }).catch((e) => {
        console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
        setIsLoaded(true) 
        setIsError(true)
      })
    
      return () => {
        controller.abort()
      }
    };

    const handleSort = (column : string, descending: boolean, list? : DinneyObject[]) => {
      let listToSort = list as Meal[] === undefined ? mealList : list as Meal[]
      let sortedMealList = [...listToSort!].sort((a,b) => {
        switch (column) {
          case 'amount':
              return DinneyUtil.setOrder(a.amount, b.amount, a.mealid, b.mealid, descending)
            case 'position':
              return DinneyUtil.setOrder(a.position, b.position, a.mealid, b.mealid, descending)
          default:
              return DinneyUtil.setOrder(a.details, b.details, a.mealid, b.mealid, descending)
        }
      })
      setMealList(sortedMealList)
      let tempFilteredMealList = sortedMealList.filter(meal => meal.active === filterActive)
      setFilteredMealList(tempFilteredMealList)
      setCount(Math.ceil(tempFilteredMealList.length/10))

    }

    const handleFilter = (phrase : string) => {
      let tempFilteredMealList = mealList.filter(meal => meal.details.toLocaleLowerCase().includes(phrase.toLowerCase()) && meal.active === filterActive)
      setCount(Math.ceil(tempFilteredMealList.length/10))
      setFilteredMealList(tempFilteredMealList)
      setFilter(phrase)
    }

    const handleFilterActive = (isActive : boolean) => {
      setPage(1)
      handleFilter('')
      let tempFilteredMealList = mealList.filter(meal => meal.active === isActive)
      setCount(Math.ceil(tempFilteredMealList.length/10))
      setFilteredMealList(tempFilteredMealList)
      setFilterActive(prev => !prev);
    }

    if (!isLoaded) {
        return (
            <PageLoader />
        )
    }
    if (isError) {
            return (
              <ErrorPage />
            )
    }

    return (
      <>
      <Container fluid className={'my-4'}>
        {isMobile ?
          <>
          <Row>
            {filteredMealList[0]?.active === true && filteredMealList.length >= MAX_MEALS  ?
              <Popover placement="right" content={'Osiągnięto maksymalną liczbę aktywnych posiłków.'}>
                  <button disabled className='button-65-mobile mb-3' onClick={() => setShow(true)}>
                    Dodaj posiłek
                  </button>
              </Popover>
            :
              <button disabled={!filterActive} className='button-65-mobile mb-3' onClick={() => setShow(true)}>
                Dodaj posiłek
              </button>
            }
          </Row>
          <Row>
          <InputGroup className="mb-1 p-0">
              <Form.Control
                value={filter}
                size="sm"
                placeholder="Filtruj po nazwie posiłku"
                aria-label="Filtruj po nazwie posiłku"
                aria-describedby="basic-addon2"
                onChange={(e) => handleFilter(e.target.value)}
              />
            </InputGroup>
            <button className='button-65-mobile' onClick={() => handleFilter('')}>
                Wyczyść
            </button>
          </Row>
          </>
        :
          <Row>
            <Col>
              {filteredMealList[0]?.active === true && filteredMealList.length >= MAX_MEALS ?
              <Popover placement="right" content={'Osiągnięto maksymalną liczbę posiłków.'}>
                <button disabled className='button-65' onClick={() => setShow(true)}>
                  Dodaj posiłek
                </button>
              </Popover>
              :
              <button disabled={!filterActive} className='button-65' onClick={() => setShow(true)}>
                  Dodaj posiłek
              </button>
              }
            </Col>
            <Col>
            </Col>
            <Col className='float-end text-end'>
            <InputGroup className="mb-3">
              <Form.Control
                value={filter}
                placeholder="Filtruj po nazwie posiłku"
                aria-label="Filtruj po nazwie posiłku"
                aria-describedby="basic-addon2"
                onChange={(e) => handleFilter(e.target.value)}
              />
              <button className='button-65' onClick={() => handleFilter('')}>
                Wyczyść
              </button>
            </InputGroup>
            </Col>
          </Row>
        }
      </Container>
      <AlertBar listLength={mealList.length} limit={MAX_MEALS} entity={Entities.MEAL}/>
      <Switch
              size = "small"
              checkedChildren="Pokaż aktywnych" 
              unCheckedChildren="Pokaż nieaktywnych"
              checked={filterActive}
              onClick={() => handleFilterActive(!filterActive)}
      />
      <Table  striped={filteredMealList !== undefined && filteredMealList.length > 0 }>
        <thead>
        <tr>
            <th>#</th>
            <th>
                <HeaderSorterColumn columnName={isMobile ? 'Poz.' : 'Pozycja'} sortCondition={'position'} handleSort={handleSort}/>
            </th>
            <th>
                <HeaderSorterColumn columnName={'Opis'} sortCondition={'details'} handleSort={handleSort}/>
            </th>
            <th>
                <HeaderSorterColumn columnName={'Kwota'} sortCondition={'amount'} handleSort={handleSort}/>
            </th>
            {isMobile
                ?
                <th className={'mobile-text-size' }>A.</th>
                :
                <>
                <th>Rodzaj stawki</th>
                <th >Akcja</th>
                </>
            }

        </tr>
        </thead>
          <tbody>
          {filteredMealList !== undefined && filteredMealList.length > 0
              ?
              filteredMealList
          .filter((meal : Meal, index : number) => {return index >= (page*10)-10 && index < page*10})
          .map((meal : Meal, index : number) => (
            <MealElement key={index} 
            meal={meal}
            customerList={customerList} 
            show={show} 
            setShow={setShow} 
            index={index} 
            handleSaveToDatabase={handleSaveToDatabase}
            handleDeleteOrRestore={handleDeleteOrRestore}
            handleHardDelete={handleHardDelete}
            isListLimitActive={mealList.filter(meal => meal.active === true).length >= MAX_MEALS}
            isListLimitInactive={mealList.filter(meal => meal.active === false).length >= MAX_MEALS}/>
            ))
        :
          <tr>
            <td colSpan={5}>
                <Empty description={<>{`${filter.length > 0 ? `Nic nie znaleziono` : `Nie dodano jeszcze posiłku`}`}</>} className='my-4'/>
            </td>
          </tr>
        }
        </tbody>
      </Table>
      <Stack spacing={2} alignItems={isMobile ? "left" : "center"}  justifyContent="center">
        <Pagination count={count} defaultPage={1} page={page} boundaryCount={2} onChange={(e, v) => setPage(v)} size="large" variant="outlined" color="secondary"/>
      </Stack>
      <SaveEditMealModal meal={null} customerList={customerList} show={show} setShow={setShow} index={null} handleSaveToDatabase={handleSaveToDatabase}/> 
      </>
    )
}